<div class="login-wrapper">
  <canvas-placeholder [showContent]="false"></canvas-placeholder>

  <div class="login-container">
    <div class="carousel-container">
      <ddc-ad-carousel></ddc-ad-carousel>
    </div>
    <div>
      <mat-card class="login-form-container">
        <form class="login-form" [formGroup]="_form" (ngSubmit)="login()">
          <div class="login-title">
            <ddc-text-gradient class="text-xl" [_text]="'Login'" [_type]="'1'"></ddc-text-gradient>
            <p class="text-sm">Let's explore, we're waiting for you.</p>
          </div>
          <!-- ! Form Error -->
          <div class="alert alert-danger" *ngIf="_form.errors">
            {{ _loginError }}
          </div>
          <!-- ! Username or Email -->
          <mat-form-field class="login-username" *ngIf="!_demoActivated">
            <mat-label>Username or Email</mat-label>
            <input formControlName="_username_or_email" matInput placeholder="Ex. mike_s96" />
            <!-- * Errors -->
            <mat-error *ngIf="username.hasError('required')"> Username is <strong>required</strong> </mat-error>
            <mat-error *ngIf="username.hasError('minlength')">
              At least <strong>{{ _minlength }}</strong> characters.
            </mat-error>
            <mat-error *ngIf="username.hasError('maxlength')">
              Maximum <strong>{{ _maxlength }}</strong> characters.
            </mat-error>
          </mat-form-field>
          <!-- ! Password -->
          <mat-form-field class="login-password" *ngIf="!_demoActivated" appearance="fill">
            <mat-label>Enter your password</mat-label>
            <input aria-label="password" formControlName="_password" matInput [type]="_hide ? 'password' : 'text'" />
            <button
              mat-icon-button
              matSuffix
              [attr.aria-label]="'Hide password'"
              [attr.aria-pressed]="_hide"
              (click)="_hide = !_hide"
            >
              <mat-icon>{{ _hide ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            <mat-error *ngIf="password.hasError('pattern')">
              Password must have at least one <strong>lowercase</strong> letter, <strong>uppercase</strong> letter,
              <strong>number</strong> and <strong>special character</strong>(#-_+). At least 8 characters.
            </mat-error>
            <mat-error *ngIf="password.hasError('required')"> Password is <strong>required</strong> </mat-error>
          </mat-form-field>
          <!-- ! Submit button -->
          <ddc-button-s-one
            [_icon]="'login'"
            [_isLoading]="_isLoginBtnLoading"
            [_label]="_submitBtnText"
            (buttonClick)="login()"
          ></ddc-button-s-one>
        </form>

        <mat-divider></mat-divider>
        <!-- ! Route -->
        <div class="login-secondary-elems" *ngIf="!_demoActivated">
          <div class="login-secondary-button">
            <a
              routerLink="/find_account"
              style="
                color: #8f8f8f;
                cursor: pointer;
                font-weight: 400;
                display: flex;
                align-items: center;
                gap: 4px;
                font-size: small;
              "
            >
              <mat-icon style="vertical-align: middle">lock_reset</mat-icon>
              Forgotten password?
            </a>
          </div>
          <div class="login-secondary-button">
            <ddc-button-r-one
              [dynamicRoute]="'/signup'"
              [icon]="'celebration'"
              [label]="'Create Daydic Account'"
              [type]="'route'"
            >
            </ddc-button-r-one>
            <ddc-appstore-btn-small></ddc-appstore-btn-small>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
</div>
